const initialState = {
	getApplicationAccess: null,
	isAddingNewKey: false
};

const applicationAccessReducer = ( state = initialState, action ) => {
	switch (action.type) {
		case "GET_APPLICATION_ACCESS":
			state = {
				...state,
				getApplicationAccess: action.payload
			};
			break;
		case "IS_ADDING_NEW_KEY":
			state = {
				...state,
				isAddingNewKey: action.payload
			};
			break;
		default :
			break;
	}
	return state;
};

export default applicationAccessReducer;
